import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueryBuilderHelper {
    constructor() { }

    //Method to remove all occurrences of ISNULL from string
    removeIsNullFromSQL(sql) {       
        return sql.replace(
          /ISNULL\s*\(\s*([A-Za-z0-9_\.\[\]]+)\s*,\s*('[^']*'|\d+(?:\.\d+)?)\s*\)\s*(=|!=|<>|>=|<=|>|<)\s*('[^']*'|\d+(?:\.\d+)?)/gi,
          (_, field, defaultVal, operator, compareVal) => {

            const cleanDefault = defaultVal.replace(/'/g, '');
            const cleanCompare = compareVal.replace(/'/g, '');

            const isDefaultZero = cleanDefault === '0';
            const isCompareZero = cleanCompare === '0';
            const isCompareQuoted = compareVal.startsWith("'");

            if (isDefaultZero && isCompareZero && isCompareQuoted) {
              return `${field} ${operator} ''`;
            }

            return `${field} ${operator} ${compareVal}`;
          }
        );
  }

  updateConsentEmailAndConsentSMSFields(filter) {
  
    let value = filter;

    if (filter.includes("Consent_Email") || filter.includes("Consent_SMS")) {

      switch (filter) {
        case 'ISNULL(Consent_Email, \'\') != \'1\'':
          value = 'Consent_Email = 0'
          break;
        case 'ISNULL(Consent_Email, \'\') = \'1\'':
          value = 'Consent_Email is null or  Consent_Email = 1'
          break;
        case 'ISNULL(Consent_Email, \'\') != \'0\'':
          value = 'Consent_Email is null or  Consent_Email = 1'
          break;
        case 'ISNULL(Consent_Email, \'\') = \'0\'':
          value = 'Consent_Email = 0'
          break;
        case 'ISNULL(Consent_SMS, \'\') != \'1\'':
          value = 'Consent_SMS = 0'
          break;
        case 'ISNULL(Consent_SMS, \'\') = \'1\'':
          value = 'Consent_SMS is null or  Consent_SMS = 1'
          break;
        case 'ISNULL(Consent_SMS, \'\') != \'0\'':
          value = 'Consent_SMS is null or  Consent_SMS = 1'
          break;
        case 'ISNULL(Consent_SMS, \'\') = \'0\'':
          value = 'Consent_SMS = 0'
          break;
        default:
          value = filter;
      }
    }

    return value;
  }
}
